import PropTypes from 'prop-types';
import { BsFunnel, BsXLg } from 'react-icons/bs';

/**
 * Chip summary of the active table filters above a table. The filters themselves live in the
 * column-header popovers (and search inputs); this bar makes them removable at a glance.
 */
const FilterChipsBar = ({ chips, resultLabel, onRemove, onClearAll }) => {
	if (chips.length === 0) return null;

	return (
		<div className="flex items-center gap-2 flex-wrap mb-2.5 animate-fadeIn">
			<span className="inline-flex items-center gap-1 text-xs font-medium text-bgBase-800">
				<BsFunnel className="w-3.5 h-3.5" /> Gefiltert:
			</span>
			{chips.map((chip) => (
				<span
					key={chip.id}
					className="inline-flex items-center gap-1.5 pl-2.5 pr-1 py-1 text-xs font-medium rounded-full bg-purple-50 text-primary-700 border border-purple-200 animate-fadeIn"
				>
					{chip.label}
					<button
						type="button"
						onClick={() => onRemove(chip.paramKeys)}
						className="p-0.5 rounded-full hover:bg-purple-100"
						title="Filter entfernen"
					>
						<BsXLg className="w-2.5 h-2.5" />
					</button>
				</span>
			))}
			<button
				type="button"
				onClick={onClearAll}
				className="text-[11px] text-bgBase-800 hover:text-text hover:underline"
			>
				Alle entfernen
			</button>
			{resultLabel && <span className="ml-auto text-xs text-bgBase-800 tabular-nums">{resultLabel}</span>}
		</div>
	);
};

FilterChipsBar.propTypes = {
	chips: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			paramKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
		}),
	).isRequired,
	/** e.g. "42 von 150 Firmen" */
	resultLabel: PropTypes.string,
	onRemove: PropTypes.func.isRequired,
	onClearAll: PropTypes.func.isRequired,
};

export default FilterChipsBar;
